export interface RoomCard {
  name: string;
  description: string;
  photo?: string;
  priceLabel?: string;
  selectionToken: string;
  expiresAt: string;
}
export interface RoomCardsAttachment {
  type: "room_cards";
  version: 1;
  cards: RoomCard[];
}
export function readRoomCards(value: unknown): RoomCardsAttachment | undefined {
  if (!value || typeof value !== "object") return undefined;
  const obj = value as { roomCards?: RoomCardsAttachment; attachments?: unknown[] };
  const candidate = obj.roomCards ?? obj.attachments?.find((item) =>
    !!item && typeof item === "object" && (item as { type?: string }).type === "room_cards");
  if (!candidate || typeof candidate !== "object") return undefined;
  const data = candidate as RoomCardsAttachment;
  if (data.type !== "room_cards" || data.version !== 1 || !Array.isArray(data.cards)) return undefined;
  return { ...data, cards: data.cards.filter((c) => c && typeof c.name === "string" && typeof c.description === "string" && typeof c.selectionToken === "string" && typeof c.expiresAt === "string") };
}

/** Price is display metadata; unavailable or legacy cards must never imply zero. */
export function roomCardPrice(card: RoomCard): string {
  const label = card.priceLabel;
  return typeof label === "string" && label.trim() && label.length <= 80 && !/[\r\n]/.test(label)
    ? label.trim()
    : "Check availability for price";
}
